import React, { useState, useRef } from 'react';
import { gsap } from 'gsap';
import { reducedMotion } from '../../../hooks/useLenis.js';
import { submitForm } from '../../../lib/submitForm.js';
import './ContactForm.css';

export const ContactForm = () => {
  const [statusText, setStatusText] = useState('');
  const statusRef = useRef(null);

  const [sending, setSending] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    const form = event.currentTarget;
    setSending(true);
    try {
      await submitForm('/api/contact', form);
      form.reset();
      setStatusText('Thank you. Your enquiry has been sent and we will be in touch shortly.');
    } catch (err) {
      setStatusText(err.message);
    } finally {
      setSending(false);
    }

    if (!reducedMotion() && statusRef.current) {
      gsap.fromTo(
        statusRef.current,
        { opacity: 0, y: -6 },
        { opacity: 1, y: 0, duration: 0.4, ease: 'power2.out' }
      );
    }
  };

  return (
    <form className="form" data-form data-reveal="fade" onSubmit={handleSubmit}>
      <input className="skip" type="text" name="website" tabIndex={-1} autoComplete="off" aria-hidden="true" />
      <div className="field">
        <label htmlFor="first-name">First name</label>
        <input
          id="first-name"
          name="firstName"
          type="text"
          autoComplete="given-name"
          required
        />
      </div>
      <div className="field">
        <label htmlFor="last-name">Last Name</label>
        <input
          id="last-name"
          name="lastName"
          type="text"
          autoComplete="family-name"
          required
        />
      </div>
      <div className="field">
        <label htmlFor="email">Email address</label>
        <input
          id="email"
          name="email"
          type="email"
          autoComplete="email"
          required
        />
      </div>
      <div className="field">
        <label htmlFor="phone">Phone Number</label>
        <input id="phone" name="phone" type="tel" autoComplete="tel" />
      </div>
      <div className="field form-wide">
        <label htmlFor="message">Message</label>
        <textarea
          id="message"
          name="message"
          rows={5}
          placeholder="How can we help you?"
        />
      </div>
      <div className="field form-wide">
        <button className="btn" type="submit" disabled={sending}>
          {sending ? 'Sending…' : 'Send enquiry'}
        </button>
        <p
          ref={statusRef}
          data-form-status
          role="status"
          style={{ marginTop: '1rem', fontSize: '0.9rem' }}
        >
          {statusText}
        </p>
      </div>
    </form>
  );
};